import { render } from "./CodeDiff.vue?vue&type=template&id=749d6e14&scoped=true"
import script from "./CodeDiff.vue?vue&type=script&lang=js"
export * from "./CodeDiff.vue?vue&type=script&lang=js"

import "./CodeDiff.vue?vue&type=style&index=0&id=749d6e14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-749d6e14"]])

export default __exports__